import { useNavigate } from "react-router-dom";

// Images
import homeJourneyPot from "../../../assets/img/HomePage/Desktop/home_journey_pot.png";
import homeJourneyChefHat from "../../../assets/img/HomePage/Desktop/home_journey_chef_hat.png";
import homeJourneyHotPot from "../../../assets/img/HomePage/Desktop/home_journey_hot_pot.png";

const HomeBeginJourney = () => {
  const navigate = useNavigate();

  return (
    <section className="px-[120px] py-[100px] text-text-1000">
      <div className="bg-primaryDark-400 p-[80px] rounded-[24px] relative max-w-[1550px] mx-auto">
        {/* Text Box */}
        <div className="max-w-[900px]">
          <h1 className="text-[64px] font-raleway leading-tight mb-[24px]">
            We connect passionate{" "}
            <span className="font-bold"> food entrepreneurs </span>
            with <span className="font-bold"> resource providers </span> who are
            ready to maximize their space.
          </h1>

          <h4 className="text-[24px] font-raleway leading-tight mb-[24px]">
            Begin your journey with HomeCook by letting us know if you’re a…
          </h4>

          {/* Buttons */}
          <div className="flex items-center gap-[16px]">
            <p>
              <button
                className="flex items-center justify-center gap-[8px] border-2 border-text-1000 px-[24px] py-[12px] text-[14px] text-text-1000 font-semibold font-raleway rounded-[8px] hover:bg-primaryDark-0/20 hover:text-text-1000 transition-all"
                onClick={() => {
                  navigate("/food-entrepreneurs");
                }}
              >
                Food Entrepreneur
              </button>
            </p>

            <p>
              <button
                className="flex items-center justify-center gap-[8px] bg-text-1000 border-2  border-text-1000 px-[24px] py-[12px] text-[14px] text-primaryDark-0 font-semibold font-raleway rounded-[8px] hover:bg-primaryDark-0/20 hover:text-text-1000 transition-all"
                onClick={() => {
                  navigate("/resource-providers");
                }}
              >
                Resource Provider
              </button>
            </p>
          </div>
        </div>

        {/* Icons */}
        <div>
          <img
            src={homeJourneyPot}
            alt="Home Journey Pot"
            className="absolute top-[80px] left-0 w-[67px] h-[112px]"
          />
          <img
            src={homeJourneyChefHat}
            alt="Home Journey Chef Hat"
            className="absolute bottom-0 right-[50%] translate-x-[50%] w-[112px] h-[72px]"
          />
          <img
            src={homeJourneyHotPot}
            alt="Home Journey Hot Dog"
            className="absolute top-[180px] right-0 w-[57px] h-[112px]"
          />
        </div>
      </div>
    </section>
  );
};

export default HomeBeginJourney;
